import { defineField, defineType } from "sanity";

export const journeyContentType = defineType({
  type: "document",
  name: "journeyContent",
  title: "Journey Content",
  groups: [{ name: "meta", title: "Meta" }],
  fields: [
    // name
    defineField({
      name: "name",
      type: "string",
      title: "Name",
      validation: (Rule) => Rule.required()
    }),

    // identifier
    defineField({
      name: "identifier",
      type: "string",
      title: "Identifier",
      validation: (Rule) => Rule.required()
    }),

    defineField({
      name: "type",
      type: "string",
      initialValue: "time-based",
      options: {
        list: [
          { title: "Time based", value: "time-based" },
          { title: "Task Based", value: "task-based" },
          { title: "Other", value: "other" }
        ]
      }
    }),

    // task program reference
    defineField({
      name: "taskProgramReference",
      type: "string",
      title: "Task Program Reference",
      group: "meta",
      hidden: ({ document }) => document?.type !== "task-based"
    }),

    defineField({
      name: "interval",
      type: "number",
      title: "Interval",
      initialValue: 14,
      hidden: ({ document }) => document?.type !== "time-based"
    }),

    defineField({
      name: "listOfClasses",
      type: "array",
      of: [{ type: "reference", to: [{ type: "classContent" }] }],
      title: "List of Classes",
      validation: (Rule) => Rule.required()
    }),

    defineField({
      name: "language",
      type: "string",
      hidden: true,
      validation: (Rule) => Rule.required()
    })
  ]
});
